module.exports = __webpack_public_path__ + "9a195fa75ff1de7094cc226e4f1c8d7f.svg";